export interface ArrowButtonProps {
  orientation: ORIENTATION;
}

export enum ORIENTATION {
  LEFT,
  RIGHT,
}
